import { useMemo, useCallback } from 'react';
import { useAutomationFiltersContext } from './AutomationFiltersContext';
import { FiltersRenderer } from '../../common/filters/filters-renderer/FiltersRenderer';
import { Filters } from '../../common/filters/filters-renderer/types';

export const AutomationsFilters = ({
  forceCompact,
  filters,
}: {
  forceCompact?: boolean;
  filters: Filters;
}) => {
  const { filterValues, setFilterValue, clearAllFilterValues } = useAutomationFiltersContext();

  const handleFilterChange = useCallback(
    (filterKey: string, values: string[]) => {
      setFilterValue(filterKey, values);
    },
    [setFilterValue],
  );

  // Convert filters to FiltersRenderer format and sort by position
  const sortedFilters = useMemo(() => {
    if (!filters) return {};

    // Sort by position and return as ordered object
    const sortedEntries = Object.entries(filters)
      .filter(([key]) => key in filters)
      .map(([key]) => [key, filters[key]]);

    return Object.fromEntries(sortedEntries);
  }, [filters]);

  const withPanelWrapper = forceCompact;

  return (
    <FiltersRenderer
      filters={sortedFilters}
      filterValues={filterValues}
      onFilterChange={handleFilterChange}
      onClearAll={clearAllFilterValues}
      withPanelWrapper={withPanelWrapper}
      gap={2}
    />
  );
};
